export default "/fonts/RV-Harmonia-Bold.ttf?7f7401ff074f8722784515b28b6e69cb";